import React from "react";
import { useData } from "../context/data/DataState";
import { Tabs, TabsList, TabsTrigger } from "../ui/tabs";
import ViewChallengeBlock from "./ViewChallengeBlock";

const ChallengesLinear = () => {
  const { data, communityId, seasonId, challengeId, setChallengeId } =
    useData();

  const handleChange = (newchallengeId) => {
    setChallengeId(newchallengeId);
  };
  
  return (
    <div className="p-4 space-y-4">
      <Tabs value={challengeId} onValueChange={handleChange}>
        <TabsList className="w-full overflow-x-auto flex-nowrap justify-start">
          {Object.values(
            data.community[communityId]?.season[seasonId]?.challenge || {}
          ).map((item, index) => (
            <TabsTrigger
              value={item.challenge_id}
              key={item.challenge_id}
              className="whitespace-nowrap"
            >
              Challenge {index + 1}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      
      {challengeId && (
        <ViewChallengeBlock
          item={
            data.community[communityId]?.season[seasonId]?.challenge[
              challengeId
            ]
          }
          index={
            Object.keys(
              data.community[communityId]?.season[seasonId]?.challenge || {}
            ).indexOf(challengeId)
          }
        />
      )}
    </div>
  );
};

export default ChallengesLinear;
